'use client'

import Image from 'next/image'

export default function SizeGuidePage() {
    return (
        <main className="mx-auto max-w-6xl px-4 py-10">
            <section className="text-center mb-12">
                <h1 className="mb-4">
                    Таблицы размеров для одежды и обуви
                </h1>
                <p className="text-gray-600 text-lg">
                    Чтобы одежда сидела хорошо, снимайте мерки правильно
                </p>
            </section>

            <section className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-20">
                <div className="flex justify-center">
                    <Image
                        src="/img/sizes-chema.png"
                        alt="Как снимать мерки"
                        width={420}
                        height={520}
                    />
                </div>

                <div className="space-y-8">
                    <div>
                        <h3 className="font-semibold text-lg mb-1">
                            A — Обхват груди
                        </h3>
                        <p className="text-gray-600">
                            Измеряйте грудь горизонтально в самом широком месте.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-lg mb-1">
                            B — Талия
                        </h3>
                        <p className="text-gray-600">
                            Измеряйте талию горизонтально чуть выше пупка (на
                            пару см). Важно для полукомбинезонов и комбинезонов.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-lg mb-1">
                            C — Бёдра
                        </h3>
                        <p className="text-gray-600">
                            Измеряйте бёдра по горизонтали в самом широком
                            месте.
                        </p>
                    </div>
                </div>
            </section>

            {/* Women */}
            <section className="mb-20">
                <h2 className="text-2xl font-semibold mb-6">
                    Таблицы размеров одежды для женщин
                </h2>

                <h3 className="font-medium mb-3">Женские куртки, толстовки</h3>
                <div className="overflow-x-auto mb-10">
                    <table className="w-full border border-gray-200 text-sm">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="border px-3 py-2">EUR</th>
                                <th className="border px-3 py-2">RU</th>
                                <th className="border px-3 py-2">
                                    Обхват груди
                                </th>
                                <th className="border px-3 py-2">
                                    Обхват талии
                                </th>
                                <th className="border px-3 py-2">
                                    Обхват бёдер
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {[
                                ['XS', '40/42', '80–84', '58–62', '88–92'],
                                ['S', '44/46', '88–92', '66–71', '96–100'],
                                ['M', '48/50', '96–100', '75–79', '104–108'],
                                ['L', '52/54', '104–108', '83–88', '112–116'],
                                ['XL', '56/58', '112–116', '93–98', '120–124'],
                                [
                                    '2XL',
                                    '60/62',
                                    '120–124',
                                    '103–108',
                                    '128–132',
                                ],
                            ].map((row) => (
                                <tr key={row[0]}>
                                    {row.map((cell, i) => (
                                        <td
                                            key={i}
                                            className="border px-3 py-2 text-center"
                                        >
                                            {cell}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <h3 className="font-medium mb-3">
                    Женские брюки, полукомбинезоны
                </h3>
                <div className="overflow-x-auto">
                    <table className="w-full border border-gray-200 text-sm">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="border px-3 py-2">RU</th>
                                <th className="border px-3 py-2">
                                    Обхват талии
                                </th>
                                <th className="border px-3 py-2">
                                    Обхват бёдер
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {[
                                40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62,
                            ].map((ru, i) => (
                                <tr key={ru}>
                                    <td className="border px-3 py-2 text-center">
                                        {ru}
                                    </td>
                                    <td className="border px-3 py-2 text-center">
                                        {58 + i * 4}
                                    </td>
                                    <td className="border px-3 py-2 text-center">
                                        {88 + i * 4}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
            <section>
                <h2 className="text-2xl font-semibold mb-6">
                    Таблицы размеров одежды для мужчин
                </h2>

                <h3 className="font-medium mb-3">
                    Мужские куртки, жилеты, толстовки
                </h3>
                <div className="overflow-x-auto mb-10">
                    <table className="w-full border border-gray-200 text-sm">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="border px-3 py-2">EUR</th>
                                <th className="border px-3 py-2">RU</th>
                                <th className="border px-3 py-2">
                                    Обхват груди
                                </th>
                                <th className="border px-3 py-2">
                                    Обхват талии
                                </th>
                                <th className="border px-3 py-2">
                                    Обхват бёдер
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {[
                                ['XS', '42/44', '84–88', '72–76', '88–92'],
                                ['S', '46/48', '92–96', '80–84', '96–100'],
                                ['M', '50/52', '100–104', '88–92', '104–108'],
                                ['L', '54', '108', '96', '112'],
                                [
                                    'XL',
                                    '56/58',
                                    '112–116',
                                    '100–104',
                                    '116–120',
                                ],
                                [
                                    '2XL',
                                    '60/62',
                                    '120–124',
                                    '108–112',
                                    '124–128',
                                ],
                            ].map((row) => (
                                <tr key={row[0]}>
                                    {row.map((cell, i) => (
                                        <td
                                            key={i}
                                            className="border px-3 py-2 text-center"
                                        >
                                            {cell}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <h3 className="font-medium mb-3">Мужские брюки, шорты</h3>
                <div className="overflow-x-auto">
                    <table className="w-full border border-gray-200 text-sm">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="border px-3 py-2">RU</th>
                                <th className="border px-3 py-2">
                                    Обхват талии
                                </th>
                                <th className="border px-3 py-2">
                                    Обхват бёдер
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {[
                                42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64,
                                66, 68, 70,
                            ].map((ru, i) => (
                                <tr key={ru}>
                                    <td className="border px-3 py-2 text-center">
                                        {ru}
                                    </td>
                                    <td className="border px-3 py-2 text-center">
                                        {72 + i * 4}
                                    </td>
                                    <td className="border px-3 py-2 text-center">
                                        {88 + i * 4}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </main>
    )
}
